module.exports = __webpack_public_path__ + "img/ParentView.9dc9479b.svg";